import { isTauri } from './is-tauri';

export interface PlatformConfig {
  /**
   * App-side read of the Tauri dev override — the wiring passes
   * `process.env.NEXT_PUBLIC_IS_TAURI === 'true'` (G1/F5: env is injected,
   * never read in package source).
   */
  tauriDevOverride: boolean;
  /**
   * App-side "not production" signal — the wiring passes
   * `getEnvironment() !== ENV_NAME.PROD`.
   */
  isDev: boolean;
}

/**
 * One-time app-bootstrap injection seam for platform detection.
 *
 * Detection itself (./is-tauri) needs no configuration — this call only
 * carries the dev-time misconfiguration guard that lived inside `isTauri()`
 * before the move: running inside a Tauri WebView in non-production without
 * the override set fails loudly here, at bootstrap, instead of at the first
 * `isTauri()` call. Production skips the check exactly as before.
 */
export function configurePlatform(config: PlatformConfig): void {
  if (isTauri() && config.isDev && !config.tauriDevOverride) {
    throw new Error(
      'NEXT_PUBLIC_IS_TAURI environment variable must be set to "true" when running in Tauri.\n' +
        'Add NEXT_PUBLIC_IS_TAURI=true to your .env file.'
    );
  }
}
